import InstructionsWrapper from '@cohort/components-xps/components/apps/InstructionsWrapper';
import i18nComponentsXpsInstance from '@cohort/components-xps/lib/i18n';
import type {StravaBeActiveTriggerStruct} from '@cohort/shared/apps/strava/triggers/beActive';
import type {InstructionsComponentProps} from '@cohort/shared/apps/trigger';
import {getI18n, useTranslation} from 'react-i18next';

const StravaBeActiveTriggerIntegrationInstructionsComponent: React.FC<
  InstructionsComponentProps<StravaBeActiveTriggerStruct>
> = ({selectedLanguage}) => {
  const {t} = useTranslation('components', {
    keyPrefix: 'apps.strava.triggers.be-active',
    lng: selectedLanguage ?? getI18n().language,
    i18n: i18nComponentsXpsInstance,
  });

  return (
    <InstructionsWrapper>
      <ul className="mt-2 list-disc pl-6">
        <li>
          <p>{t('instructionsStep1')}</p>
        </li>
        <li>
          <p>{t('instructionsStep2')}</p>
        </li>
        <li>
          <p>{t('instructionsStep3')}</p>
        </li>
        <li>
          <p>{t('instructionsStep4')}</p>
        </li>
      </ul>
    </InstructionsWrapper>
  );
};

export default StravaBeActiveTriggerIntegrationInstructionsComponent;
